import uuid from 'uuid/v1';

const items = [];

const components = [
  {
    content: 'TitleLineH1',
    readableName: 'TitleH1',
    component: {
      type: 'TitleLineH1',
      text: {
        es: '',
        en: '',
        ca: '',
        pt: '',
      },
      color: 'black',
    },
  },
  {
    content: 'SimpleTag',
    readableName: 'Tag',
    component: {
      type: 'SimpleTag',
      text: {
        es: '',
        en: '',
        ca: '',
        pt: '',
      },
      category: '',
    },
  },
  {
    content: 'LinkButtonRounded',
    readableName: 'CTA Button',
    text: {
      es: '',
      en: '',
      ca: '',
      pt: '',
    },
    url: '',
  },
  {
    content: 'SubtitleLineH2',
    readableName: 'Subtitle',
    text: {
      es: '',
      en: '',
      ca: '',
      pt: '',
    },
  },
  {
    content: 'PretitleLineH2',
    readableName: 'Pretitle',
    text: {
      es: '',
      en: '',
      ca: '',
      pt: '',
    },
  },
];

components.forEach((comp) => {
  const mod = {
    id: uuid(),
    content: comp.content,
    readableName: comp.readableName,
    type: 'item',
  };
  items.push(mod);
});

export default items;
